var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/utils.ts
var notBrowser = typeof window === "undefined" || typeof document === "undefined";
var cached = {
  getEnvironmentName: null,
  isIOS: null,
  isAndroidOS: null,
  isNativeWebView: null,
  isIOSWebView: null,
  isAndroidWebView: null,
  isMobileOS: null,
  isMobileBrowser: null,
  isDesktop: null
};
var reset = () => {
  cached.getEnvironmentName = null;
  cached.isMobileOS = null;
  cached.isIOS = null;
  cached.isDesktop = null;
  cached.isIOS = null;
  cached.isAndroidOS = null;
  cached.isAndroidWebView = null;
  cached.isIOSWebView = null;
};
var isMobileOS = (userAgent) => {
  cached.isMobileOS = cached.isMobileOS !== null ? cached.isMobileOS : /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );
  return cached.isMobileOS;
};
var isDesktop = (userAgent) => {
  cached.isDesktop = cached.isDesktop !== null ? cached.isDesktop : !isMobileOS(userAgent);
  return cached.isDesktop;
};
var isIOS = (userAgent) => {
  cached.isIOS = cached.isIOS !== null ? cached.isIOS : /iphone|ipod|ipad/.test(userAgent.toLowerCase());
  return cached.isIOS;
};
var isAndroidOS = (userAgent) => {
  cached.isAndroidOS = cached.isAndroidOS !== null ? cached.isAndroidOS : userAgent.toLowerCase().indexOf("android") > -1;
  return cached.isAndroidOS;
};
var isIOSWebView = (userAgent, isStandalone) => {
  cached.isIOSWebView = cached.isIOSWebView !== null ? cached.isIOSWebView : isIOS(userAgent) && !isStandalone && /AppleWebKit/i.test(userAgent);
  return cached.isIOSWebView;
};
var isAndroidWebView = (cookiesSayAndroid) => {
  cached.isAndroidWebView = cached.isAndroidWebView !== null ? cached.isAndroidWebView : cookiesSayAndroid;
  return cached.isAndroidWebView;
};
var getEnvironmentName = () => {
  const { userAgent } = window.navigator;
  const cookiesSayAndroid = document.cookie.indexOf("Device=Android") > -1;
  const isStandalone = window.navigator.standalone;
  if (!cached.getEnvironmentName) {
    const prefix = isDesktop(userAgent) ? "desktop" : "mobile";
    let platform;
    let suffix;
    if (isAndroidOS(userAgent)) {
      platform = "android";
      suffix = isAndroidWebView(cookiesSayAndroid) ? "native" : "browser";
    } else if (isIOS(userAgent)) {
      platform = "ios";
      suffix = isIOSWebView(userAgent, isStandalone) ? "native" : "browser";
    } else {
      platform = "web";
      suffix = "browser";
    }
    cached.getEnvironmentName = `${prefix}-${platform}-${suffix}`;
  }
  return cached.getEnvironmentName;
};
var tenantId = "";
var setTenantId = (tenantIdValue) => {
  tenantId = tenantIdValue;
};
var getTenantId = () => tenantId;

// src/google-analytics/google-analytics.js
var currentGAPropertyID = null;
var getGtag = () => window.gtag || (() => {
});
var initGoogleAnalytics = (GAPropertyID) => {
  if (notBrowser)
    return false;
  currentGAPropertyID = GAPropertyID;
  return getGtag()("config", GAPropertyID, { send_page_view: false });
};
var sendGoogleAnalytics = (params) => {
  const data = {
    event_action: params.action,
    event_category: params.category,
    event_label: params.label,
    value: params.value
  };
  getGtag()("event", params.action, data);
  return data;
};
var sendGoogleAnalyticsPageView = (params) => {
  const data = __spreadValues({
    page_title: params.screen_name,
    page_path: params.path
  }, params);
  getGtag()("event", "page_view", data);
  return data;
};
var setDimension = (name, value) => {
  if (!currentGAPropertyID)
    return;
  getGtag()("config", currentGAPropertyID, {
    custom_map: { [name]: value }
  });
};

// src/league-analytics/league-analytics.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var sendAnalyticsToLeague = (params, name) => __async(void 0, null, function* () {
  const payload = {
    name,
    params: __spreadProps(__spreadValues({}, params), {
      platform: "web",
      environment: getEnvironmentName(),
      userAgent: window.navigator.userAgent
    }),
    echo: true
  };
  SocketAsFetch.fetch({
    message_type: "set_analytics_event",
    info: payload
  });
});

// src/utils/utils.loadScript.js
var loadScript = (src) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.setAttribute("async", "true");
  script.setAttribute("src", src);
  document.documentElement.firstChild.appendChild(script);
};

// src/segment/segment-sdk.js
var loadSegmentSDK = () => {
  const analytics = window.analytics = window.analytics || [];
  if (analytics.initialize)
    return;
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error("Segment snippet included twice.");
    }
    return;
  }
  analytics.invoked = true;
  analytics.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on"
  ];
  analytics.factory = function(method) {
    return function() {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  analytics.load = function(key, options) {
    loadScript(
      `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`
    );
    analytics._loadOptions = options;
  };
  analytics.SNIPPET_VERSION = "4.1.0";
};

// src/segment/segment.utils.ts
var noop = () => {
};
var noopSegmentAnalytics = {
  load: noop,
  identify: noop,
  page: noop,
  track: noop,
  ready: noop
};
var getSegment = () => window.analytics || noopSegmentAnalytics;

// src/segment/segment.ts
var pageIsLoaded = false;
var initSegment = (SegmentKey, segmentOptions) => {
  if (notBrowser)
    return false;
  loadSegmentSDK();
  window.onload = () => {
    const waitInterval = setInterval(() => {
      if (typeof window.analytics === "object") {
        clearInterval(waitInterval);
        pageIsLoaded = true;
        getSegment().load(SegmentKey, segmentOptions);
      }
      return pageIsLoaded;
    }, 250);
  };
  return pageIsLoaded;
};
var segmentIdentify = (user) => getSegment().identify(user.id, user);
var sendSegmentEvent = (eventName, props) => {
  const tenantId2 = getTenantId();
  getSegment().track(eventName, __spreadProps(__spreadValues({}, props), { tenant_id: tenantId2 }));
};

// src/constants.ts
var GA_EVENT = "ga_event";
var EVENT_NAME = /* @__PURE__ */ ((EVENT_NAME2) => {
  EVENT_NAME2["BUTTON_CLICKED"] = "button clicked";
  EVENT_NAME2["NAVIGATION_TAB_CLICKED"] = "navigation tab clicked";
  EVENT_NAME2["NAVIGATION_BAR_CLICKED"] = "navigation bar clicked";
  EVENT_NAME2["RESOURCE_CLICKED"] = "resource clicked";
  EVENT_NAME2["SCREEN_LOADED"] = "screen loaded";
  EVENT_NAME2["QUERY_RETURNED"] = "query returned";
  return EVENT_NAME2;
})(EVENT_NAME || {});
var PRODUCT_AREA = /* @__PURE__ */ ((PRODUCT_AREA2) => {
  PRODUCT_AREA2["APPS_AND_DEVICES"] = "apps and devices";
  PRODUCT_AREA2["HEALTH_ASSESSMENTS"] = "health assessments";
  PRODUCT_AREA2["JOURNEY"] = "health journey";
  PRODUCT_AREA2["ONBOARDING"] = "onboarding";
  PRODUCT_AREA2["REWARDS"] = "rewards";
  PRODUCT_AREA2["WALLET"] = "wallet";
  PRODUCT_AREA2["ENROLLMENT"] = "enrollment";
  PRODUCT_AREA2["HR_ADMIN"] = "hr admin";
  PRODUCT_AREA2["GET_CARE"] = "get care";
  PRODUCT_AREA2["CARE"] = "care";
  PRODUCT_AREA2["HOME_SCREEN"] = "home screen";
  PRODUCT_AREA2["SETTINGS"] = "settings";
  PRODUCT_AREA2["CLAIMS"] = "claims";
  PRODUCT_AREA2["LOGIN"] = "login";
  return PRODUCT_AREA2;
})(PRODUCT_AREA || {});
var SUB_PRODUCT_AREA = /* @__PURE__ */ ((SUB_PRODUCT_AREA2) => {
  SUB_PRODUCT_AREA2["CHALLENGES"] = "challenges";
  SUB_PRODUCT_AREA2["POINTS"] = "points";
  SUB_PRODUCT_AREA2["CHAT"] = "chat";
  SUB_PRODUCT_AREA2["DOCUMENTS"] = "documents";
  SUB_PRODUCT_AREA2["MESSAGING"] = "messaging";
  SUB_PRODUCT_AREA2["ACCOUNT_SET_UP"] = "account set up";
  SUB_PRODUCT_AREA2["ACHIEVEMENTS"] = "achievements";
  SUB_PRODUCT_AREA2["HOMESCREEN"] = "homescreen";
  SUB_PRODUCT_AREA2["CALLBACK"] = "callback";
  SUB_PRODUCT_AREA2["LIVE_CHAT"] = "live chat";
  SUB_PRODUCT_AREA2["CLAIM_DETAILS"] = "claim details";
  SUB_PRODUCT_AREA2["CLAIMS"] = "claims";
  SUB_PRODUCT_AREA2["SUMMARY"] = "summary";
  SUB_PRODUCT_AREA2["RECENT_CLAIMS_WIDGET"] = "recent claims widget";
  SUB_PRODUCT_AREA2["MAINTENANCE"] = "maintenance";
  return SUB_PRODUCT_AREA2;
})(SUB_PRODUCT_AREA || {});
var SCREEN_NAMES = /* @__PURE__ */ ((SCREEN_NAMES2) => {
  SCREEN_NAMES2["HOME_PAGE"] = "home page";
  SCREEN_NAMES2["HOMEPAGE"] = "homepage";
  SCREEN_NAMES2["HOME_SCREEN"] = "home screen";
  SCREEN_NAMES2["HOME"] = "home";
  SCREEN_NAMES2["BENEFIT_PAGE"] = "benefit page";
  SCREEN_NAMES2["FEATURE_HIGHLIGHT"] = "feature highlight";
  SCREEN_NAMES2["CARE_COLLECTION"] = "care collection";
  SCREEN_NAMES2["CARE_COLLECTIONS"] = "care collections";
  SCREEN_NAMES2["CARE_COLLECTIONS_MENU"] = "care collections menu";
  SCREEN_NAMES2["CARE_DOCUMENTS"] = "care documents";
  SCREEN_NAMES2["HEALTH_CAMPAIGN_DETAIL"] = "health campaign detail";
  SCREEN_NAMES2["HEALTH_PROFILE"] = "health profile";
  SCREEN_NAMES2["MY_DOCUMENTS"] = "my documents";
  SCREEN_NAMES2["ALL_DOCUMENTS"] = "all documents";
  SCREEN_NAMES2["DELETE_DOCUMENT"] = "delete document";
  SCREEN_NAMES2["RENAME_DOCUMENT"] = "rename document";
  SCREEN_NAMES2["ADD_A_DOCUMENT"] = "add a document";
  SCREEN_NAMES2["QUICK_ACTION_DETAIL"] = "quick action detail";
  SCREEN_NAMES2["SETTINGS"] = "settings";
  SCREEN_NAMES2["SUPPORT"] = "support";
  SCREEN_NAMES2["DELETE_ACCOUNT"] = "delete account";
  SCREEN_NAMES2["COMMUNICATION_PREFERENCES"] = "communication preferences";
  SCREEN_NAMES2["PERSONAL_INFO"] = "personal info";
  SCREEN_NAMES2["ACCOUNT_SET_UP"] = "account set up";
  SCREEN_NAMES2["CALLBACK_REQUEST_FORM"] = "callback request form";
  SCREEN_NAMES2["CALLBACK_REQUEST_CONFIRMATION"] = "callback request confirmation";
  SCREEN_NAMES2["HEALTH_REPORT_PAGE"] = "health report page";
  SCREEN_NAMES2["CLAIM_DETAILS"] = "claim details";
  SCREEN_NAMES2["SUMMARY"] = "summary";
  SCREEN_NAMES2["HELPFUL_LINKS"] = "helpful links";
  SCREEN_NAMES2["FILTERS"] = "filters";
  SCREEN_NAMES2["RECENT_CLAIMS_WIDGET"] = "recent claims widget";
  SCREEN_NAMES2["MAINTENANCE_PAGE"] = "maintenance page";
  return SCREEN_NAMES2;
})(SCREEN_NAMES || {});

// src/analytics.ts
var config = null;
var initAnalytics = (analyticsConfig, tenantId2) => {
  config = analyticsConfig;
  setTenantId(tenantId2);
  if (analyticsConfig.GAPropertyId) {
    initGoogleAnalytics(analyticsConfig.GAPropertyId);
  }
  if (analyticsConfig.segmentKey) {
    initSegment(analyticsConfig.segmentKey);
  }
};
var identify = (user) => {
  if (!user)
    return;
  segmentIdentify(user);
  if (config == null ? void 0 : config.onIdentify) {
    try {
      config.onIdentify(user);
    } catch (error) {
      console.error("There was an error in the onIdentify method:", error);
    }
  }
};
var trackAnalyticsEvent = (eventName, props = {}) => {
  if (typeof eventName !== "string")
    throw new Error("Analytics - eventName argument must be of type string");
  sendSegmentEvent(eventName, props);
  const legacyParams = __spreadValues({
    category: props.screen_name,
    action: props.detail,
    label: props.sub_detail || props.sub_product_area
  }, props);
  sendGoogleAnalytics(legacyParams);
  sendAnalyticsToLeague(legacyParams, GA_EVENT);
  if (config == null ? void 0 : config.onTrackEvent) {
    try {
      config.onTrackEvent(eventName, props);
    } catch (error) {
      console.error("There was an error in the onTrackEvent method:", error);
    }
  }
};
var sendAnalyticsEvent = (params, name = GA_EVENT) => {
  sendGoogleAnalytics(params);
  sendAnalyticsToLeague(params, name);
  sendSegmentEvent("button clicked" /* BUTTON_CLICKED */, params);
};
var sendAnalyticsPageView = (params, name = GA_EVENT) => {
  const props = __spreadValues({
    screen_name: params.title,
    path: params.path || window.location.pathname
  }, params);
  sendGoogleAnalyticsPageView(props);
  sendAnalyticsToLeague(props, name);
  sendSegmentEvent("screen loaded" /* SCREEN_LOADED */, props);
  if (config == null ? void 0 : config.onTrackPageViewEvent) {
    try {
      config.onTrackPageViewEvent(props.screen_name, props);
    } catch (error) {
      console.error(
        "There was an error in the onTrackPageViewEvent method:",
        error
      );
    }
  }
};

// src/use-analytics.hooks.ts
import { useEffect } from "react";
var usePageViewAnalytics = (params, dependencies = [], name = GA_EVENT) => {
  if (!Array.isArray(dependencies))
    throw new Error("Provided hook dependencies must be an array");
  useEffect(() => {
    sendAnalyticsPageView(params, name);
  }, dependencies);
};
export {
  EVENT_NAME,
  GA_EVENT,
  PRODUCT_AREA,
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  getEnvironmentName,
  identify,
  initAnalytics,
  isAndroidOS,
  isAndroidWebView,
  isDesktop,
  isIOS,
  isIOSWebView,
  isMobileOS,
  loadScript,
  notBrowser,
  reset,
  sendAnalyticsEvent,
  sendAnalyticsPageView,
  setDimension,
  trackAnalyticsEvent,
  usePageViewAnalytics
};
//# sourceMappingURL=index.js.map